module.exports = __webpack_public_path__ + "static/media/inoxGuard.d7b00219.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/inoxGuard.png
// module id = 122
// module chunks = 0